export const GET_GROUP_BUYING_REPORT_LIST = 'GET_GROUP_BUYING_REPORT_LIST';
export const GET_GROUP_BUYING_REPORT_LIST_DONE = 'GET_GROUP_BUYING_REPORT_LIST_DONE';
export const GET_MEMBER_REPORT = 'GET_MEMBER_REPORT';
export const GET_TEMP_REPORT = 'GET_TEMP_REPORT';
export const GET_MEMBER_REPORT_LIST = 'GET_MEMBER_REPORT_LIST';
export const GET_MEMBER_REPORT_LIST_DONE = 'GET_MEMBER_REPORT_LIST_DONE';
export const GET_MEMBER_REPORT_RANGE = 'GET_MEMBER_REPORT_RANGE';
export const GETTING_GROUP_BUYING_REPORT_LIST = 'GETTING_GROUP_BUYING_REPORT_LIST';
export const GETTING_MEMBER_REPORT_LIST = 'GETTING_MEMBER_REPORT_LIST';
export const SET_MEMBER_REPORT_RANGE = 'SET_MEMBER_REPORT_RANGE';
export const SET_SEARCH_DATE_TYPE = 'SET_SEARCH_DATE_TYPE';
